export default __webpack_public_path__ + "static/media/invest_navicon-light.d855df99.svg";